import React from "react";
import { Message, Button, Icon } from "semantic-ui-react";
import Dropzone from "react-dropzone";
import axios from "axios";
import { connect } from "react-redux";
import { Progress } from "semantic-ui-react";
import { updateProfileImage } from "../reducers/accountDetails";
import { withTranslation } from "react-i18next";

const Preview = (props) => {
  return props.error ? (
    <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
      <Icon name="exclamation circle" />
      <div style={{ marginTop: "5px", fontSize: "14px" }}>{props.error}</div>
    </div>
  ) : props.file ? (
    <div style={{ textAlign: "center", padding: "10px" }}>
      <img
        style={{
          maxWidth: "100%",
          maxHeight: "150px",
          borderRadius: "4px"
        }}
        src={props.file.preview}
        alt="Profile preview"
      />
      <div style={{ marginTop: "8px", color: "#666", fontSize: "13px" }}>
        <Icon name="check circle" color="green" />
        {props.uploadedText || "Image loaded"}
      </div>
    </div>
  ) : (
    <div style={{ textAlign: "center", padding: "30px 20px" }}>
      <Icon name="cloud upload" size="large" color="grey" style={{ marginBottom: "10px" }} />
      <div style={{ fontSize: "14px", color: "#666" }}>
        {props.text}
      </div>
      <div style={{ color: "#999", fontSize: "12px", marginTop: "5px" }}>
        {props.dragText || "or drag and drop your image here"}
      </div>
    </div>
  );
};

class PictureUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { file: null, error: null, uploadPercentage: 0 };
    this.text = props.text
      ? props.text
      : this.props.t("PictureUploader.clickToUpload");
  }

  componentDidMount = () => {
    let image = new Image();

    image.addEventListener("error", (error) => {
      console.log(error);
    });

    image.addEventListener("load", () => {
      this.setState({
        file: {
          preview: image.src,
        },
      });
    });

    image.src =
      `${process.env.REACT_APP_API_ADDRESS}/api/images/profile/` +
      `${this.props.kc.tokenParsed.sub}_user_profile_img.png?token=${
        this.props.kc.token
      }&cb=${Math.round(new Date().getTime() / 1000)})`;
  };

  onDrop = (files, rejected) => {
    if (files[0]) {
      let image = new Image();
      let file = files[0];

      this.setState({ error: null });

      image.addEventListener("load", () => {
        this.setState({
          file: {
            preview: window.URL.createObjectURL(file),
          },
        });

        const data = new FormData();
        data.append("photo", file);
        data.append("user_id", this.props.kc.tokenParsed.sub);
        axios
          .post(process.env.REACT_APP_API_ADDRESS + "/api/upload", data, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.setState({ uploadPercentage: 100 }, () => {
              setTimeout(() => {
                this.setState({ uploadPercentage: 0 });
              }, 1000);
            });
            this.props.updateProfileImage(true);
          })
          .catch((error) => {
            console.log("error: ", error);
          });
      });

      image.src = window.URL.createObjectURL(file);
    } else {
      let error = "";
      if (rejected[0].size > 2097152) {
        error = this.props.t("PictureUploader.fileTooLargeError");
      } else {
        error = this.props.t("PictureUploader.incorrectFileTypeError");
      }
      this.setState({ error: error });
    }
  };

  render() {
    const { uploadPercentage } = this.state;

    return (
      <React.Fragment>
        <Dropzone
          onDrop={this.onDrop.bind(this)}
          maxSize={5242880}
          accept={{
            "image/png": [".png"],
            "image/jpeg": [".jpg", ".jpeg"],
          }}
        >
          {({ getRootProps, getInputProps, isDragActive, open }) => (
            <section>
              <div
                {...getRootProps({ className: "dropzone" })}
                style={{
                  maxWidth: "100%",
                  minHeight: "200px",
                  borderWidth: isDragActive ? "2px" : "1px",
                  borderColor: isDragActive ? "#2185d0" : "#d4d4d5",
                  borderStyle: "dashed",
                  borderRadius: "5px",
                  backgroundColor: isDragActive ? "#f0f8ff" : "#fafafa",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  position: "relative",
                }}
              >
                <input {...getInputProps()} />
                {isDragActive && (
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(33, 133, 208, 0.1)",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#2185d0",
                    zIndex: 10,
                  }}>
                    <Icon name="download" size="big" />
                    Drop your image here
                  </div>
                )}
                <Preview
                  file={this.state.file}
                  text={this.text}
                  error={this.state.error}
                  dragText={this.props.t("PictureUploader.dragDropText")}
                  uploadedText={this.props.t("PictureUploader.imageLoaded")}
                />
                {uploadPercentage > 0 && (
                  <Progress percent={uploadPercentage} indicating />
                )}
              </div>
              <div style={{ textAlign: "center", marginTop: "15px" }}>
                <Button
                  primary
                  size="medium"
                  icon
                  labelPosition="left"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    open();
                  }}
                >
                  <Icon name="upload" />
                  {this.props.t("PictureUploader.uploadButton")}
                </Button>
                <div style={{ marginTop: "8px", color: "#999", fontSize: "12px" }}>
                  {this.props.t("PictureUploader.fileRequirements")}
                </div>
              </div>
            </section>
          )}
        </Dropzone>
      </React.Fragment>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
    }),
    { updateProfileImage }
  )(PictureUploader)
);
